import { AdsType } from 'lib/apis/services/ads';
import Image from 'next/image';

function Banner(props: AdsType.BannerItemNewVersion) {
  return (
    <>
      <a
        href={props.link}
        target="_blank"
        rel="noreferrer"
        className="flex items-center justify-center"
      >
        <Image
          src={props.banner}
          width={props.width ? props.width: 200}
          height={props.height ? props.height: 300}
          alt={props.id.toString()}
          placeholder="blur"
          blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcvgAAAfQBSWu8iX0AAAAASUVORK5CYII="
          onError={(err) => {
            err.currentTarget.src = `/images/default-image.jpg`;
            err.currentTarget.srcset = '';
          }}
        />
      </a>
    </>
  );
}

export default Banner;
